import RESTClientService from 'src/services/RESTClientService';

const restClientService = new RESTClientService();

export const SET_CLIENTS = '@types/set-clients';
export const SET_CLIENTS_ERROR = '@types/set-clients-error';
export const SET_CLIENTS_REQUEST = '@types/set-clients-request';

/**
 * Legacy setClients - maintains backward compatibility
 * @param {Array} existingReduxClients - Optional pre-fetched clients
 */
export function setClients(existingReduxClients) {
  if (existingReduxClients) {
    return (dispatch) => {
      dispatch({
        type: SET_CLIENTS,
        payload: {
          clients: existingReduxClients,
        }
      });
    };
  }
  const request = restClientService.getClientList();
  return (dispatch) => {
    request.then((response) => {
      dispatch({
        type: SET_CLIENTS,
        payload: response
      });
    });
  };
}

/**
 * Async version of setClients with proper error handling
 * Returns a Promise for use with async/await and try-catch
 * @param {Array} existingReduxClients - Optional pre-fetched clients
 * @returns {Promise<{success: boolean, data?: any, error?: any}>}
 */
export function fetchClients(existingReduxClients) {
  if (existingReduxClients) {
    return (dispatch) => {
      dispatch({
        type: SET_CLIENTS,
        payload: {
          clients: existingReduxClients,
        }
      });
      return Promise.resolve(existingReduxClients);
    };
  }

  return async (dispatch) => {
    try {
      dispatch({ type: SET_CLIENTS_REQUEST });

      const response = await restClientService.getClientList();

      dispatch({
        type: SET_CLIENTS,
        payload: response
      });

      return response;
    } catch (error) {
      dispatch({
        type: SET_CLIENTS_ERROR,
        payload: error
      });

      throw error;
    }
  };
}
